import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { TaxRateShiftsDto } from '../dtos';

export class TaxRateShiftsState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public taxrateShifts: { [taxRateShiftId: number]: TaxRateShiftsDto };

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.taxrateShifts = null;
  }
}
